/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonTypography from "components/ArgonTypography";

const activityAttendanceTableData3 = (notes = []) => {
  const rows = (Array.isArray(notes) ? notes : []).map((entry, index) => {
    const dateValue = entry?.createdAt ? new Date(entry.createdAt) : null;
    const dateLabel =
      dateValue && !Number.isNaN(dateValue.getTime())
        ? dateValue.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : "NA";

    return {
      "S.No.": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      "Date & Time": (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {dateLabel}
        </ArgonTypography>
      ),
      Notes: (
        <ArgonTypography variant="caption" color="text" fontWeight="medium">
          {entry?.note || "NA"}
        </ArgonTypography>
      ),
    };
  });

  return {
    columns: activityAttendanceTableData3.columns,
    rows,
  };
};

activityAttendanceTableData3.columns = [
  { name: "S.No.", align: "center" },
  { name: "Date & Time", align: "center" },
  { name: "Notes", align: "center" },
];

activityAttendanceTableData3.rows = [];

export default activityAttendanceTableData3;
